import React from 'react'
import Count from '../../Common/Count/Count'
import MetrixVisual from './MetrixVisual'
import styles from './Metrix.module.scss'

const stats = [
  { value: '12', text: 'Startup projects completed' },
  { value: '8', text: 'Sectors' },
  { value: '100+', text: 'Technology EIR community' },
  { value: '3', text: 'New engagements' },
]

const Meterix = () => {
  return (
    <div className={styles['metrix-wrapper']}>
      <div className={styles['container']}>
        <div className={styles['media']}>
          <MetrixVisual />
        </div>

        <div className={styles['content-container']}>
          <p className={styles['text-1']}>Build better, launch faster</p>
          <p className={styles['text-2']}>
            We&rsquo;re only just getting started on our journey
          </p>
          <p className={styles['text-3']}>
            From idea to launch, we build, fund, and scale ventures across
            sectors &mdash; turning bold concepts into market-ready products
            with the right technology, capital, and expertise.
          </p>

          <div className={styles['count-container']}>
            {stats.map((stat) => (
              <div key={stat.text} className={styles['count']}>
                <Count value={stat.value} text={stat.text} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Meterix
